var firebaseConfig = {
  apiKey: "AIzaSyBmNm9OP1WunsL9YQpO6NMoEYkKY9XwT4k",
  authDomain: "creative-agency-22.firebaseapp.com",
  databaseURL: "https://creative-agency-22.firebaseio.com",
  projectId: "creative-agency-22",
  storageBucket: "creative-agency-22.appspot.com",
  messagingSenderId: "55904557849",
  appId: "1:55904557849:web:44d0be81ba9e5d0a2cc388"
};
  export default firebaseConfig;